// extracted by mini-css-extract-plugin
module.exports = {"agentInfo":"PanelInsert_agentInfo__i6Sm7"};